import classNames from 'classnames';
import React, {useEffect} from 'react'
import DonationForm from 'components/DonationForm'
import parser from 'html-react-parser'
import {
    innerMobileHeroBg,

} from './Hero2.module.css'
export default function Hero2({ data }) {
    const { hero2Text, hero2Title, hero2DesktopImage, hero2MobileImage, hero2Video } = data

    useEffect(() => {
        // Set a flag in localStorage or sessionStorage
        const shouldReload = sessionStorage.getItem('shouldReload') === 'true';

        if (shouldReload) {
            // Clear the flag to prevent a reload loop
            sessionStorage.setItem('shouldReload', 'false');
        } else {
            // Set the flag before reloading
            sessionStorage.setItem('shouldReload', 'true');
            setTimeout(() => {
                window.location.reload();
            }, 500); // The delay is 5000ms (5 seconds)
        }

        // No cleanup needed here as we're reloading the page, which will clear the timeout
    }, []);

    return (
        <div
            className='inner-banner m-blue-overlay vid-inr-wrap hero-overlay font-white donation-hero-wrap'
            style={{
                background: `url(${hero2DesktopImage?.localFile.publicURL}) left bottom no-repeat`,
            }}
        >
            <div
                className={classNames('inner-mobile-hero-bg', innerMobileHeroBg)}
                style={{
                    background: `url(${hero2MobileImage?.localFile.publicURL}) left bottom no-repeat`,
                }}
            ></div>
            <video className='home-hero-video' muted loop autoPlay='play'>
                <source src={hero2Video?.localFile.publicURL} type='video/webm' />
            </video>
            <div className='container h-vid-container'>
                <div className='row'>
                    <div className='col-md-6'>
                        <h1 className='heading-level-1'>{hero2Title && parser(hero2Title)}</h1>
                        <p>{hero2Text && parser(hero2Text)}</p>
                    </div>
                    <div className='col-md-6'>
                        <div className='donation-frm-sec'>
                            <DonationForm />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
